import { ChangeDetectionStrategy, Component } from '@angular/core';
import { TranslocoDirective } from '@jsverse/transloco';
import { CardComponent, ContentComponent } from '@lyceo/shared/ui';
import { TaskCountsComponent } from '@lyceo/shared/task-count/feature-main';

@Component({
  selector: 'lib-homi-home-home-page',
  templateUrl: './home-page.component.html',
  styleUrl: './home-page.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    TranslocoDirective,
    ContentComponent,
    CardComponent,
    TaskCountsComponent,
  ],
})
export class HomePageComponent {}
